export const SHOPPING_AIDS_ITEM = [
  {
    item: 'Ellie',
    itemImageDesktop: '/images/listItem/ellie/desktop/700px/tissue-Boxes-Ellie.webp',
    itemImageMobile: '/images/listItem/ellie/mobile/335px/tissue-Boxes-Ellie.webp',
     path: '/packaging/shopping-aids/tissueBoxes/ellie',
  },
  {
    item: 'Leah',
    itemImageDesktop: '/images/listItem/leah/desktop/700px/tissue-Boxes-Leah.webp',
    itemImageMobile: '/images/listItem/leah/mobile/335px/tissue-Boxes-Leah.webp',
     path: '/packaging/shopping-aids/tissueBoxes/leah',
  },
]